import React from 'react'
import ReactDOM from 'react-dom'

// eslint-disable-next-line no-undef
const Portal = ({ children, target = document.body }) => {
  return ReactDOM.createPortal(children, target)
}

export default React.memo(Portal)
